// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Upload_wrapper__2Vmc8","label":"Upload_label__uLCtw","disabled":"Upload_disabled__2BPw4"};